/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid, Skeleton, Typography, useMediaQuery, useTheme } from "@mui/material";
import TabBofu from "@components/TabBofu/TabBofu";
import DocumentsTabBofu from "@components/TabBofu/DocumentsTabBofu";
import { InactivityHandler } from "@components/InactivityHandler";
import { BOFU_TABS_CONFIG } from "@helpers/constantes";
import CustomRightImage from "@components/CustomRightImagev2";
import { RootState, useAppDispatch } from "@store/store";
import { useSelector } from "react-redux";
import { setBofuTabGarantiaDocument } from "@store/slices/bofuSlice";
import ButtonContinue from "@components/TabBofu/ButtonContinue";
import React from "react";
import { CustomCompanyName } from "@components/CustomCompanyName";

const DocsGarantia = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const bufuLoading = useSelector((state: RootState) => state.bofu.isLoading);
  const bofuTabGarantia = useSelector((state: RootState) => state.bofu.bofu_tabs_obj.garantia);

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8} mt={2}>
        <Box textAlign={"center"} mx={4}>
          <InactivityHandler />

          <CustomCompanyName />

          <TabBofu />

          {bufuLoading ? (
            <Box mt={4}>
              <Skeleton variant="rectangular" height={100} sx={{ borderRadius: 2 }} />
            </Box>
          ) : (
            <React.Fragment>
              <Typography
                variant={isMobileOrTablet ? "body2" : "body1"}
                fontWeight={400}
                color={theme?.palette?.primary?.main}
                mt={4}
                mb={4}
              >
                Por favor proporciona la información del vehículo o inmueble que dejarás como garantía para tu crédito
              </Typography>

              {bofuTabGarantia.items.length === 0 && (
                <Typography
                  color={theme?.palette?.primary?.dark}
                  fontSize={"20px"}
                  textAlign={"center"}
                  fontWeight={600}
                >
                  No se encontraron garantias registradas
                </Typography>
              )}

              {bofuTabGarantia.items.map((item, index) => (
                <Box mt={4} key={item.guarantee.id}>
                  <Typography mt={4} mb={3} fontSize={"20px"} fontWeight={600} color={theme?.palette?.primary?.dark}>
                    {item.title}
                  </Typography>
                  <DocumentsTabBofu
                    inputPrefix={`garantia_${index}`}
                    tabCode={BOFU_TABS_CONFIG.tab_garantia.code}
                    documents={item.documents}
                    onChange={({ document, newValue }) => {
                      dispatch(
                        setBofuTabGarantiaDocument({
                          guarantee: item.guarantee,
                          document,
                          newValue,
                          valueAction: undefined,
                          valueIndex: undefined,
                        }),
                      );
                    }}
                    onChangeMultiple={({ document, newValue, valueAction, valueIndex }) => {
                      dispatch(
                        setBofuTabGarantiaDocument({
                          guarantee: item.guarantee,
                          document,
                          newValue,
                          valueAction,
                          valueIndex,
                        }),
                      );
                    }}
                  />
                </Box>
              ))}

              <Box mt={4}>
                <ButtonContinue tabCode={BOFU_TABS_CONFIG.tab_garantia.code} />
              </Box>
            </React.Fragment>
          )}
        </Box>
      </Grid>
      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default DocsGarantia;
